import { render, staticRenderFns } from "./setting.vue?vue&type=template&id=f3e4296c&scoped=true&"
import script from "./setting.vue?vue&type=script&lang=js&"
export * from "./setting.vue?vue&type=script&lang=js&"
import style0 from "./setting.vue?vue&type=style&index=0&id=f3e4296c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3e4296c",
  null
  
)

export default component.exports